import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import {
  CapaQuotationAnnotationCommentMessage,
  CapaQuotationChatMessage
} from '@generated/graphql';
import { colorSet } from '@components/Provider';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { useSelector } from '@store';
import openViewer from '@utils/popupViewer';

const useStyles = makeStyles(() => {
  return {
    root: {
      width: 230,
      borderRadius: 10,
      backgroundColor: colorSet.gray000
    },
    content: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      padding: '16px'
    },
    wordBreak: {
      wordBreak: 'break-all'
    },
    buttonContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '16px'
    }
  };
});

interface Props {
  message?: CapaQuotationChatMessage;
}

const NewAnnotationBubble: React.FC<Props> = ({ message }) => {
  const chatRoomId = useSelector((state) => state?.chat?.chatRoomId || '');
  const rfqId = useSelector((state) => state?.chat?.rfqId || '');
  const classes = useStyles();
  const {
    annotation
  } = message?.message as CapaQuotationAnnotationCommentMessage;
  if (!annotation) return null;

  const toAnnotation = () => {
    const { fileId, annotationId, id } = annotation;
    if (!fileId || !annotationId) return;

    openViewer({
      rfqId,
      chatRoomId,
      selectedFileId: fileId,
      annotation: {
        id: annotationId,
        commentId: id || ''
      }
    });
  };

  return (
    <Box className={classes.root}>
      <div className={classes.content}>
        <div className="header">
          <CustomizedTypography
            variant="body2"
            fontWeight="bold"
            color="inherit"
          >
            새로운 주석
          </CustomizedTypography>
        </div>
        <CustomizedTypography variant="body2" className={classes.wordBreak}>
          {annotation.userName} 님이 도면에 새로운 주석을 남겼습니다.
          <br />
          <br />
          {annotation.comment}
        </CustomizedTypography>
      </div>
      <div className={classes.buttonContainer}>
        <CustomizedButton
          color="primary"
          variant="contained"
          fullWidth
          onClick={toAnnotation}
        >
          주석 위치로 이동
        </CustomizedButton>
      </div>
    </Box>
  );
};

export default NewAnnotationBubble;
